const confirmar_estimativa_de_matricula_por_rede = {
  path: "/confirmar-estimativa-de-matricula-por-rede",
  redirect: "/confirmar-estimativa-de-matricula-por-rede",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Confirmar Estimativa de Matrícula",
  },
  children: [
    {
      path: "/confirmar-estimativa-de-matricula-por-rede",
      name: "confirmar-estimativa-de-matricula-por-rede",
      component: () =>
        import(
          "@/views/ConfirmarEstimativaDeMatriculaporRede/ConfirmarEstimativaDeMatriculaPorRedeNovos.vue"
        ),
    },
  ],
};

export { confirmar_estimativa_de_matricula_por_rede };
